// matches any number between -90 and +90 with a maximum of 6 decimal digits
export const regexCenterLat =
    /^(?!-0(?:\.0+)?$)-?(?:90(?:\.0{1,6})?|[1-8]?\d(?:\.\d{1,6})?)$/gm
// matches any number between -180 and +180 with a maximum of 6 decimal digits
export const regexCenterLon =
    /^(?!-0(?:\.0*)?$)-?(?:180(?:\.0{1,6})?|1[0-7]\d(?:\.\d{1,6})?|[1-9]?\d(?:\.\d{1,6})?)$/gm
// matches any positive number between 0(excluded) and 90(excluded) with a maximum of 6 decimal digits
export const regexHwidthLat =
    /^(0\.(?!0+$)\d{1,6}|([1-9]|[1-8]\d)(?:\.\d{1,6})?)$/gm;
// matches any positive number between 0(excluded) and 180(excluded) with a maximum of 6 decimal digits
export const regexHwidthLon =
    /^(0\.(?!0+$)\d{1,6}|([1-9]|[1-9]\d|1[0-7]\d)(?:\.\d{1,6})?)$/gm;

// matches any positive number between 0(excluded) and 180(excluded) with a maximum of 6 decimal digits
export const regexPoleLon =
    /^-?(?:180(?:\.0{1,6})?|1[0-7]\d(?:\.\d{1,6})?|[1-9]?\d(?:\.\d{1,6})?|0(?:\.0{1,6})?)$/gm;
// matches any positive number between 0(excluded) and 180(excluded) with a maximum of 6 decimal digits
export const regexPoleLat =
    /^-?(?:90(?:\.0{1,6})?|[1-8]?\d(?:\.\d{1,6})?|0(?:\.0{1,6})?)$/gm

// matches any value between 0 and 360 with a maximum of 6 decimal digits
export const lonIcoRotation =
    /^(360(\.0{1,6})?|3[0-5][0-9](\.[0-9]{1,6})?|[0-2]?[0-9][0-9](\.[0-9]{1,6})?|[0-9](\.[0-9]{1,6})?)$/gm
// matches any float > 0.5
export const rnbkDesiredRes = /^$|^(?:[1-9][0-9]*(?:\.[0-9]+)?|0\.[5-9][0-9]*)$/gm;

// matches any positive integer
export const positiveInt = /^[1-9]\d*$/gm;
// matches any positive integer between 0 and 100
export const positiveInt100 = /^(100|[1-9]|[0-9]{1,2})$/gm;
//matches a float
export const floatNumber = /^-?([0-9]+(\.[0-9]+)?|0\.[0-9]+)$/gm;
// matches any string
export const any = /^.*$/gm;
// matches alphabets (lower and uppercase), numbers and the characters "-", "_" & "."
export const outfile = /^[A-Za-z0-9._-]+$/gm;

